import { ITheme } from '@/store/theme/interface'

export const themeConfig: ITheme = {
	sidebarStyle: 'light',
	headerStyle: 'light',
	primaryColor: '#0BB2D4',
	uniqueOpened: true,
	isLogo: true,
	isBreadcrumb: true,
	isTabsView: true,
	isTabsCache: true,
	tabsStyle: 'style-1'
}
